export default "__VITE_ASSET__Liz0yMYA__$_?url__"